module.exports = __webpack_public_path__ + "media/images/search-7fb37e4302945105ad3896f3626f14d4.png";